export default function( size, url ){
		if( url ){
			url = url.split('.')
			url.pop()
			return url.join('.') + size + '.jpg'
		}
		return ''
	}
